import React from 'react';
import { Link } from 'react-router-dom';

const IntroSection = () => {
  return (
    <section className="py-20 px-6 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Side: Tagline & Elevator Pitch */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 leading-tight">
              Building immersive digital experiences with modern web technologies.
            </h2>
            <p className="mt-6 text-lg text-gray-600">
              Specializing in React ecosystems and user-centric design.
            </p>
          </div>

          {/* Right Side: CTA Button */}
          <div className="flex-1 flex justify-center lg:justify-end">
            <Link to="/about" className="group">
              <button
                className="border border-gray-700 text-gray-800 px-8 py-3 rounded transition-all hover:bg-gray-700 hover:text-white flex items-center gap-2"
              >
                About Me
                <span className="inline-block transform translate-x-0 transition-transform duration-300 ease-in-out group-hover:translate-x-2">
                  →
                </span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
